"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthClient = void 0;
const auth_1 = require("./types/auth");
const axios_1 = __importDefault(require("axios"));
const axios_better_stacktrace_1 = __importDefault(require("axios-better-stacktrace"));
const qs_1 = __importDefault(require("qs"));
const base_64_1 = require("base-64");
const utils_1 = require("./utils");
/**
 * `AuthClient` is a encapsulation of the network request logic needed to authenticate a user.
 * It's intended to be as stateless as possible to simplify testing (it only receives a reference
 * to an `AxiosInstance`, which we can mock out later to create a `MockAuthClient` for testing).
 */
class AuthClient {
    constructor({ auth, baseUrl, userAgent }) {
        this.client = axios_1.default.create({
            baseURL: baseUrl,
            timeout: 10000,
            headers: Object.assign(Object.assign(Object.assign({ 'Content-Type': 'application/x-www-form-urlencoded' }, utils_1.requestHeaderCacheControlNoStorage), (userAgent
                ? {
                    'User-Agent': userAgent,
                }
                : {})), (auth
                ? {
                    Authorization: `Basic ${(0, base_64_1.encode)(`${auth.username}:${auth.password}`)}`,
                }
                : {})),
        });
        (0, axios_better_stacktrace_1.default)(this.client);
    }
    loginViaMfa(_a) {
        return __awaiter(this, arguments, void 0, function* ({ email, password, mfaCode, rememberDevice, deviceUuid, }) {
            const resp = yield this.client.post(auth_1.AuthEndpoints.GetAccessToken, qs_1.default.stringify({
                username: email,
                password,
                grant_type: auth_1.TokenGrantType.Mfa,
                mfa_code: mfaCode,
                remember_device: rememberDevice,
                device_uuid: deviceUuid,
            }));
            return resp.data;
        });
    }
    loginViaPartner(_a) {
        return __awaiter(this, arguments, void 0, function* ({ partnerToken, userId, }) {
            const resp = yield this.client.post(auth_1.AuthEndpoints.GetAccessToken, qs_1.default.stringify({
                user_id: userId,
                partner_token: partnerToken,
                grant_type: auth_1.TokenGrantType.Partner,
            }));
            return resp.data;
        });
    }
    loginViaPassword(_a) {
        return __awaiter(this, arguments, void 0, function* ({ email, password, deviceUuid, }) {
            const resp = yield this.client.post(auth_1.AuthEndpoints.GetAccessToken, qs_1.default.stringify({
                username: email,
                password,
                device_uuid: deviceUuid,
                grant_type: auth_1.TokenGrantType.Password,
            }));
            return resp.data;
        });
    }
    refreshAccessToken(refreshToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(auth_1.AuthEndpoints.GetAccessToken, qs_1.default.stringify({
                refresh_token: refreshToken,
                grant_type: auth_1.TokenGrantType.RefreshToken,
            }));
            return resp.data;
        });
    }
}
exports.AuthClient = AuthClient;
